var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-content',{staticClass:"center-logo"},[_c('img',{staticClass:"logo",attrs:{"src":"/img/logo.svg","height":"200","alt":"Museu d'Història de Manacor"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }